export const pageSize = 30;
export const pageSizeAF3 = 200;